import resolve from 'ng';

export default resolve;